import { checkShouldRedirectToIdpUrlOnLogin } from './features/authentication/checkShouldRedirectToIdpUrlOnLogin';

const BOOTSTRAP_RELOAD_KEY = 'webeoc.bootstrapReloadAttempted';

// this is needed to have an async boundary, that ensures that shared resources are awaited when loaded on client side
async function boot() {
    const vdir = window.location.pathname.split('/')[1];
    const siteUrl = `${window.location.origin}/${vdir}`;

    const redirectUrl = await checkShouldRedirectToIdpUrlOnLogin(siteUrl, window.location.pathname);
    if (redirectUrl) {
        window.location.replace(redirectUrl);
        return;
    }

    try {
        await import('./bootstrap');
        window.sessionStorage.removeItem(BOOTSTRAP_RELOAD_KEY);
    } catch (error) {
        // A stale chunk hash from a deploy that happened while this tab was open is the common case,
        // and a single reload fetches the current index.html/chunks. Guard with sessionStorage so a
        // durable failure (bad deploy, CDN outage) surfaces instead of reload-looping forever.
        if (!window.sessionStorage.getItem(BOOTSTRAP_RELOAD_KEY)) {
            window.sessionStorage.setItem(BOOTSTRAP_RELOAD_KEY, '1');
            window.location.reload();
            return;
        }

        renderLoadFailure();
        throw error;
    }
}

// The app failed to load even after a retry, so React/i18n never became available - fall back to plain DOM.
function renderLoadFailure() {
    const app = document.getElementById('app');
    if (!app) {
        return;
    }

    app.innerHTML = '';
    const message = document.createElement('p');
    message.textContent = 'WebEOC failed to load. Please check your connection and try again.';
    const retryButton = document.createElement('button');
    retryButton.textContent = 'Retry';
    retryButton.onclick = () => window.location.reload();

    app.append(message, retryButton);
}

// boot() already renders the failure UI before re-throwing; the throw only stops boot()'s own execution, so there's nothing left to handle here.
boot().catch(() => {});
